import { StarIcon } from '@phosphor-icons/react';

import { Drawer } from '@/components/feedback/drawer';

import { useOrderReviews } from '../hooks';
import type { OrderDetail } from '../types';

import styles from './order-detail.module.scss';

type Props = { order: OrderDetail; open: boolean; onClose: () => void };

export function ReviewsDrawer({ order, open, onClose }: Props) {
  const reviews = useOrderReviews(order.id, open);
  const items = reviews.data ?? [];

  return (
    <Drawer open={open} onClose={onClose} title="Review(s)" width={464} loading={reviews.isLoading}>
      <div className={styles.reviewList}>
        {items.map((r) => (
          <div key={r.lineItemId} className={styles.reviewItem}>
            <div className={styles.reviewHead}>
              {r.productImageUrl ? (
                <img className={styles.thumb} src={r.productImageUrl} alt="" />
              ) : (
                <div className={styles.thumb} aria-hidden />
              )}
              <span className={styles.lineName}>{r.productName}</span>
              <span className={styles.stars} aria-label={`${r.rating} out of 5`}>
                {Array.from({ length: 5 }, (_, i) => (
                  <StarIcon key={i} size={16} weight={i < r.rating ? 'fill' : 'regular'} />
                ))}
              </span>
            </div>
            {r.comment && <p className={styles.reviewComment}>{r.comment}</p>}
          </div>
        ))}
        {!reviews.isLoading && items.length === 0 && (
          <p className={styles.empty}>No reviews yet.</p>
        )}
      </div>
    </Drawer>
  );
}
